import store from '@/store';

/**
 * 生成本地的购物车数据
 *
 * cartItems  {array}  购物车数据
 *
 * */
export function createLocalCartData (cartItems) {
    let cartData = [];
    cartItems.forEach((item, index) => {
        const {isChecked, productId, quantity, addFrom, type, areaType} = item;
        cartData.push({
            isChecked,
            productId,
            quantity,
            type,
            areaType
        });
        if (addFrom) {
            cartData[index].addFrom = addFrom;
        }
    });
    return cartData;
}

export function handleResCartData (cart) {
    // const _this = this;
    const {cartItems} = cart;

    // _this.setCartData(cart);
    store.dispatch('setCartData', cart);

    if (cartItems && cartItems.length > 0) {

        if (store.getters.upk) { // 有upk，登录状态
            // safari浏览器开启无痕模式后，写入本地存储会报错，防止报错
            try {
                localStorage.setItem('cloudCartData', JSON.stringify(createLocalCartData(cartItems)));
                // 登录状态下调取接口后将本地数据清除
                localStorage.removeItem('cartData');
            } catch (err) {}
        } else {
            try {
                // 非登录状态，将更新后的购物车数据存储到本地
                localStorage.setItem('cartData', JSON.stringify(createLocalCartData(cartItems)));
            } catch (err) {}
        }
    } else {
        // 返回的数据为空，清除本地数据
        try {
            localStorage.removeItem('cloudCartData');
            localStorage.removeItem('cartData');
        } catch (err) {}
    }
}



// WEBPACK FOOTER //
// ./src/public/js/public.js